import React from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  IconButton,
} from '@mui/material';
import {
  Add as AddIcon,
  ChatBubbleOutline as ChatBubbleOutlineIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import styles from 'pages/main/WizardPage/WizardPage.module.css';
import default_theme from 'assets/themes/themes';

const ChatHistory = ({
  threads,
  currentThreadId,
  onStartNewChat,
  onLoadChat,
  onDeleteChat
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        width: { xs: 0, md: 280 },
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
        borderRadius: 0,
        height: '100%',
        flexShrink: 0,
        bgcolor: "#F5F4F3",
      }}
    >
      <Box
        sx={{
          p: 2,
          borderBottom: '1px solid rgba(0,0,0,0.1)',
          flexShrink: 0,
        }}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onStartNewChat}
          fullWidth
          sx={{ mb: 2, bgcolor: '#00b894', '&:hover': { bgcolor: '#00a085' } }}
        >
          New Chat
        </Button>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
          Chat History
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          minHeight: 0,
        }}
        className={styles.scrollbar}
      >
        <List dense sx={{ p: 0 }}>
          {threads.map((thread) => (
            <ListItem
              key={thread.thread_id}
              button
              onClick={() => onLoadChat(thread.thread_id)}
              selected={currentThreadId === thread.thread_id}
              className={styles.chatHistoryItem}
              sx={{
                borderBottom: '1px solid rgba(0,0,0,0.05)',
                '&.Mui-selected': {
                  backgroundColor: '#00b894',
                  '&:hover': { backgroundColor: '#d4edda' },
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color:"#00b894"
                }}
              >
                <ChatBubbleOutlineIcon/>
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontWeight: 500 }}>{thread.title}</Typography>}
              />
              <IconButton
                size="small"
                onClick={(e) => onDeleteChat(thread.thread_id, e)}
                sx={{ opacity: 0.7, '&:hover': { opacity: 1 }, color: "#eb2f06"}}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Paper>
  );
};

export default ChatHistory;